import { mergeStyleSets } from "office-ui-fabric-react/lib/Styling";

export const classNames = mergeStyleSets({
  fileIconHeaderIcon: {
    padding: 0,
    fontSize: "16px",
  },
  fileIconCell: {
    textAlign: "center",
    selectors: {
      "&:before": {
        content: ".",
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0px",
        visibility: "hidden",
      },
    },
  },
  fileIconImg: {
    verticalAlign: "middle",
    maxHeight: "16px",
    maxWidth: "16px",
  },
  controlWrapper: {
    display: "flex",
    flexWrap: "wrap",
  },
  exampleToggle: {
    display: "inline-block",
    marginBottom: "10px",
    marginRight: "30px",
  },
  selectionDetails: {
    marginBottom: "20px",
  },
  link: {
    color: "#000",
    textDecorationColor: "#000"
  },
  subHeaderWrapper: {
    width: "95%",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    height: "50px",
  },
  breadcrumbWrapper: {
    width: "100%",
    alignSelf: "center"
  },
  searchInputWrapper: {
    alignSelf: "center"
  }
});
export const controlStyles = {
  root: {
    margin: "0 30px 20px 0",
    maxWidth: "300px",
  },
};
